import { ACCESS_PERIPHERAL_TYPES } from 'helpers/globals'
import { removeDeviceWiresAction } from 'actions/entityActions'
import removeDeviceWires from 'reducers/removeDeviceWires'

export default function deleteDoorController(state, action) {
  const { id, resetCurrentEntity } = action

  // first, remove attached wires
  const newState = removeDeviceWires(state, removeDeviceWiresAction(id, 'doorController'))

  const { entities, entities: { doorControllers, doors } } = newState

  const doorController = doorControllers.byId[id]

  if (!doorController) return newState

  const byId = { ...doorControllers.byId }
  delete byId[id]

  const doorsById = { ...doors.byId }
  doorController.doorIds.forEach(doorId => delete doorsById[doorId])

  const newPeripherals = {}
  ACCESS_PERIPHERAL_TYPES.forEach(peripheralType => {
    let newById = { ...entities[peripheralType].byId }
    let newAllIds = [ ...entities[peripheralType].allIds ]

    doorController.doorIds.forEach(doorId => {
      const door = doors.byId[doorId]
      if (door) {
        door[peripheralType].forEach(peripheralId => delete newById[peripheralId])
        newAllIds = newAllIds.filter(peripheralId => !door[peripheralType].includes(peripheralId))
      }
    })

    newPeripherals[peripheralType] = {
      allIds: newAllIds,
      byId: newById
    }
  })

  let currentEntity = { type: 'map' }

  if (doorController.isExpansion) {
    const parent = doorControllers.byId[doorController.parentId]

    if (parent) {
      byId[parent.id] = {
        ...parent,
        expansionIds: parent.expansionIds.filter(currentId => currentId !== id)
      }

      currentEntity = {
        type: 'doorController',
        id: parent.id
      }
    }
  }

  return Object.assign({}, newState, {
    entities: {
      ...entities,
      doorControllers: {
        byId,
        allIds: doorControllers.allIds.filter(currentId => currentId !== id)
      },
      doors: {
        byId: doorsById,
        allIds: doors.allIds.filter(doorId => !doorController.doorIds.includes(doorId))
      },
      ...newPeripherals
    }
  },
  resetCurrentEntity && {
    currentEntity
  })
}



// WEBPACK FOOTER //
// ./src/reducers/deleteDoorController.js